module.exports = __webpack_public_path__ + "static/media/ic_delete_confirmation.b22167e0.svg";